import {Model} from 'vue-mc';


/**
 * Task model
 */
export default class LoginModel extends Model {

    // Default attributes that define the "empty" state.
    defaults() {
        return {
            email: '',
            password: '',
            errorMessage: '',
        }
    }

    // Attribute mutations.
    mutations() {
        return {
            email: String,
            password: String,
            errorMessage: String
        }
    }
    // Attribute validation


    // Route configuration
    routes() {
        return {
            save: "contacts/login",
            resetPassword: 'contacts/password/reset'
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/loginModel.js